import {
  DateTimeRange,
  TimePeriodUnit,
} from '@modules/common/components/DateRangePicker/types';
import { UUID } from 'v2/core/entities/uuid';

const CANVA_TENANT_ID = 'd5c212e2-42bc-4349-adcf-507927621ee9';
const NETFLIX_TENANT_ID = '07aa47a2-8447-4165-9f84-781979bb15a1';
const TELLENT_TENANT_ID = 'b2567efd-be14-4575-b597-9e3f18be0cad';
const DRAFT_KINGS_TENANT_ID = '26a5fc7e-6047-4008-a12a-806a00420170';

// TODO: Remove this once we start using tenant's dashboardSettings
export const getDefaultTimeRangeForTenant = (
  tenantID: UUID,
): DateTimeRange | null => {
  switch (tenantID) {
    case CANVA_TENANT_ID:
      return {
        type: 'last',
        unit: TimePeriodUnit.Week,
        value: 4,
      };

    case NETFLIX_TENANT_ID:
      return {
        type: 'last',
        unit: TimePeriodUnit.Month,
        value: 48,
      };

    case TELLENT_TENANT_ID:
    case DRAFT_KINGS_TENANT_ID:
      return {
        type: 'last',
        unit: TimePeriodUnit.Month,
        value: 12,
      };

    default:
      return null; // null to make it explicit so we don't set default if no need
  }
};
